import LocalizedStrings from "react-localization";

export const spendsRefreshButtonStrings = new LocalizedStrings({
  en: {
    refresh: "Refresh",
    autorefresh: "Autorefresh ({0} sec.)",
  },
  fr: {
    refresh: "Actualizer",
    autorefresh: "Actualisation automatique ({0} sec.)",
  },
});
